import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatPrice(price) {
  if (!price && price !== 0) return 'Free';
  if (price === 0) return 'Free';
  return `\u20A6${price.toLocaleString()}`;
}

/**
 * Marketplace listing price label that respects `is_ticketed` so a ticketed
 * event with `event.price=0` (priced through ticket types) is NEVER labelled
 * "Free". Use this for cards, hero badges and homepage tiles.
 */
export function listingPriceLabel(item) {
  if (item?.is_ticketed) {
    const min = Number(item?.min_ticket_price);
    if (Number.isFinite(min) && min > 0) return `From \u20A6${min.toLocaleString()}`;
    return 'Tickets';
  }
  return formatPrice(item?.price);
}

/**
 * Formats a monetary balance (wallet, credits, earnings, etc.) always showing a Naira amount.
 * Unlike formatPrice(), this never returns "Free" for zero values — a balance of 0 should
 * read as `\u20A60`, not be confused with a free event ticket.
 *
 * @param {number|null|undefined} balance
 * @returns {string}
 */
export function formatBalance(balance) {
  const amount = Number(balance);
  if (!Number.isFinite(amount)) return '\u20A60';
  return `\u20A6${amount.toLocaleString()}`;
}

export function slugify(text) {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
